export default "__VITE_ASSET__BhOqPYVD__"